<div class="slideout-container">
    <dx-drawer #slideout id="navSlideOut" template="template" [(opened)]="isDrawerOpen" [closeOnOutsideClick]="drawer_closeOnOutsideClick">
        <div class="hide-print" *dxTemplate="let menuData of 'template'">
            <dx-scroll-view id="navScrollView">
                <dx-accordion id="navAccordion"
                              [dataSource]="dataSource"
                              [collapsible]="true"
                              [multiple]="true"
                              [selectedIndex]="-1"
                              [width]="300"
                              [animationDuration]="300">
                    <div *dxTemplate="let menuGroup of 'title'">
                        <span class="menu-group" *ngIf="menuGroup.longDescription=='Log In'">{{userName}}</span>
                        <div class="menu-group" *ngIf="menuGroup.longDescription!='Log In'">
                            <mat-icon class="menu-group-icon">{{menuGroup.matIcon}}</mat-icon>&nbsp;<span class="menu-group-text">{{menuGroup.longDescription}}</span>
                        </div>
                    </div>
                    <div *dxTemplate="let menuGroup of 'item'">
                        <div class="menu-item-div" *ngFor="let menuItem of menuGroup.navigationMenuItems">
                            <a class="menu-item" *ngIf="menuItem.longDescription=='Log In' && isLoggedIn==false" [routerLink]=menuItem.routerLink><span [ngClass]="['glyphicon', menuItem.glyphIcon]"></span> {{menuItem.longDescription}}</a>
                            <a class="menu-item" *ngIf="menuItem.longDescription=='Log Off'" (click)="signOut()"><span [ngClass]="['glyphicon', menuItem.glyphIcon]"></span> {{menuItem.longDescription}}</a>
                            <a class="menu-item" *ngIf="menuItem.longDescription!='Log Off' && menuItem.longDescription!='Log In'" [routerLink]=menuItem.routerLink><span [ngClass]="['glyphicon', menuItem.glyphIcon]"></span> {{menuItem.longDescription}}</a>
                        </div>
                    </div>
                </dx-accordion>
            </dx-scroll-view>
        </div>
        <dx-toolbar *ngIf="appService.isFullScreen===false" id="headerToolbar" [dataSource]="toolbarItems">
            <div *dxTemplate="let data of 'hamburger'">
                <dx-button id="mainMenuButton" class="mainHamburgerButton" icon="menu" (click)="menuClick()" [visible]="navMenuService.showMenu"></dx-button>
            </div>
            <div *ngIf="appSettingsService.fixedScreen1 != ''">
                <div *dxTemplate="let data of 'fixedscreen1'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen1Title}}"
                               type="normal" (click)="clickFixedScreen(1)"></dx-button>
                </div>
                <div *dxTemplate="let data of 'fixedscreen2'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen2Title}}"
                               type="normal" (click)="clickFixedScreen(2)"></dx-button>
                </div>
                <div *dxTemplate="let data of 'fixedscreen3'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen3Title}}"
                               type="normal" (click)="clickFixedScreen(3)"></dx-button>
                </div>
                <div *dxTemplate="let data of 'fixedscreen4'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen4Title}}"
                               type="normal" (click)="clickFixedScreen(4)"></dx-button>
                </div>
                <div *dxTemplate="let data of 'fixedscreen5'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen5Title}}"
                               type="normal" (click)="clickFixedScreen(5)"></dx-button>
                </div>
                <div *dxTemplate="let data of 'fixedscreen6'">
                    <dx-button stylingMode="contained"
                               text="{{appSettingsService.fixedScreen6Title}}"
                               type="normal" (click)="clickFixedScreen(6)"></dx-button>
                </div>
            </div>
            <div *dxTemplate="let data of 'title'">
                <h2 class="page-title">{{pageTitle ? pageTitle.longTitle : ''}}</h2>
            </div>
            <div *dxTemplate="let data of 'branding'">
                <img *ngIf="!navMenuService.showMenu" class="brandimg company-header-logo"
                     [fxFlex]="(appSettingsService.companyLogoHeaderWidth + 'px')"
                     fxHide.xs src="{{appSettingsService.companyLogoHeader}}"
                     alt="Company" />
                <img *ngIf="!navMenuService.showMenu" id="imgBranding" class="brandimg"
                     [fxFlex]="(appSettingsService.brandLogoHeaderWidth + 'px')" src="{{appSettingsService.brandLogo}}" alt="Brand" />
                <a *ngIf="navMenuService.showMenu" class='navbar-brand' [routerLink]="['/start']">
                    <div fxLayout="row" style="padding-top:2px">
                        <img *ngIf="appSettingsService.companyLogoHeader != ''" class="brandimg company-header-logo"
                             [fxFlex]="(appSettingsService.companyLogoHeaderWidth + 'px')"
                             fxHide.xs src="{{appSettingsService.companyLogoHeader}}" alt="Company" />
                        <img *ngIf="appSettingsService.brandLogo != ''" id="imgBranding" class="brandimg"
                             [fxFlex]="(appSettingsService.brandLogoHeaderWidth + 'px')" src="{{appSettingsService.brandLogo}}"
                             alt="Brand" />
                    </div>
                    <!--<img fxHide.gt-xs id="imgBrandingSplit2" class="brandimg" src="../../../../assets/images/company/vflogoinverse.svg" alt="Viper Freight" />-->
                </a>
            </div>
        </dx-toolbar>
        <loading-panel></loading-panel>
        <router-outlet></router-outlet>
    </dx-drawer>
</div>
